<ng-container *ngIf="isLoading; else content">
	<div class="spinner-container">
		<img width="50" src="assets/spinners/bouncing-balls.svg" alt="Loading..." />
	</div>
</ng-container>

<ng-template #content>
	<ng-container *ngTemplateOutlet="loadedContent"></ng-container>
</ng-template>
